/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconEqualNot = createReactComponent("outline", "equal-not", "IconEqualNot", [["path", { "d": "M5 10h14", "key": "svg-0" }], ["path", { "d": "M5 14h14", "key": "svg-1" }], ["path", { "d": "M5 19l14 -14", "key": "svg-2" }]]);

export { IconEqualNot as default };
//# sourceMappingURL=IconEqualNot.mjs.map
